import Typography, { TypographyElement } from "../RedesignTypography"

import { Color } from "../components/typography"
import React from "react"
import { types } from "react-bricks/frontend"

interface FootnoteItemProps {
    text: TypographyElement[]
    id: string
}

const FootnoteItem: types.Brick<FootnoteItemProps> = ({ id }) => {
    return (
        <div id={id}>
            <Color>
                <Typography
                    size="UI4"
                    allowList={["bold", "sup", "link", "small"]}
                    propName="text"
                    className="pl-[1.15em] -indent-[1.15em]"
                />
            </Color>
        </div>
    )
}

FootnoteItem.schema = {
    name: "FootnoteItem",
    label: "Footnote Item",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "id",
            label: "Anchor Id",
            type: types.SideEditPropType.Text,
        },
    ],
    getDefaultProps: (): FootnoteItemProps => ({
        id: "",
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
                    },
                ],
            },
        ],
    }),
}

export default FootnoteItem
